<template>
  <v-app>
    <div class="home">
      <AppSearch />
      <AppHeader></AppHeader>

      <AppHelp></AppHelp>
      <v-main>
        <AppSpinner v-if="$store.state.loading"></AppSpinner>
        <router-view />
      </v-main>
      <AppFooter></AppFooter>
    </div>
  </v-app>
</template>

<script>
// Components
import AppSearch from "@/components/AppSearch.vue";
import AppHeader from "@/components/AppHeader.vue";
import AppSpinner from "@/components/AppSpinner.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppHelp from "@/components/AppHelp.vue";

export default {
  name: "App",
  components: {
    AppHeader,
    AppSearch,
    AppSpinner,
    AppFooter,
    AppHelp,
  },
};
</script>
<style></style>
